import {
  AvatarMutationResponseSchema,
  ProfileIdentityMutationResponseSchema,
  ProfileSettingsSchema,
  type ProfileSettings,
  type ProfileSubject,
} from "@herskin/contracts";
import { api } from "./api";

export const PROFILE_UPDATED_EVENT = "herskin:profile-updated";

export async function loadProfile() {
  return ProfileSettingsSchema.parse(await api<unknown>("/api/profile"));
}

export async function uploadAvatar(subject: ProfileSubject, file: File) {
  const result = AvatarMutationResponseSchema.parse(
    await api<unknown>(`/api/profile/avatars/${subject}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/octet-stream",
        "X-HerSkin-Profile-Mime-Type": file.type,
      },
      body: await file.arrayBuffer(),
    }),
  );
  window.dispatchEvent(new CustomEvent(PROFILE_UPDATED_EVENT));
  return result.profile;
}

export async function deleteAvatar(subject: ProfileSubject) {
  const result = AvatarMutationResponseSchema.parse(
    await api<unknown>(`/api/profile/avatars/${subject}`, { method: "DELETE" }),
  );
  window.dispatchEvent(new CustomEvent(PROFILE_UPDATED_EVENT));
  return result.profile;
}

export async function saveProfileDisplayName(subject: ProfileSubject, displayName: string) {
  const result = ProfileIdentityMutationResponseSchema.parse(
    await api<unknown>(`/api/profile/identities/${subject}`, {
      method: "PUT",
      body: JSON.stringify({ displayName }),
    }),
  );
  window.dispatchEvent(new CustomEvent(PROFILE_UPDATED_EVENT));
  return result.profile;
}

export type { ProfileSettings };
